export default __webpack_public_path__ + "./images/kw.4ef025b6.png";